export default __webpack_public_path__ + "assets/images/1384f15746d9fac2b502592904aa6edc.png";